export enum SessionRouteNames {
    LOGIN = 'login',
    PROFILE = 'self-profile',
    CHANGE_PASSWORD = 'self-change-password'
}

export enum EmployeeRouteNames {
    LIST = 'employees-list',
    NEW = 'employees-new',
    EDIT = 'employees-edit',
    SINGLE = 'employees-single',
}

export enum OrganizationsRouteNames {
    LIST = 'organizations-list',
    NEW = 'organizations-new',
    SHOW = 'organizations-show',
    SHOW_HISTORY = 'organizations-show-history',
    MEMBERS = 'organizations-members',
    MEMBERS_SHOW = 'organizations-members-show',
    MEMBERS_NEW = 'organizations-members-new',
    BILLING_TEMPLATE_NEW = 'organizations-billing-template-new',
    BILLING_TEMPLATE_SHOW = 'organizations-billing-template-show'
}

export enum PackagesRouteNames {
    LIST = 'packages-list',
    NEW = 'packages-new',
    EDIT = 'packages-edit',
}

export enum AgreementsRouteNames {
    LIST = 'agreements-list',
    NEW = 'agreements-new',
    NEW_FORM = 'agreements-new-form',
    EDIT = 'agreements-edit',
    SHOW = 'agreements-show',
    MEMBERS = 'agreements-members',
    BILLING_INFO ='agreements-billing-info',
    SEARCH_MEMBERS = 'agreements-search-members'
}

export enum MembersRouteNames {
    LIST = 'members-list',
    NEW = 'members-new',
    SHOW = 'members-show',
}

export enum JobTitlesRouteNames {
    LIST = 'job-titles-list',
    NEW = 'job-titles-new',
    EDIT = 'job-titles-edit',
}

export enum FreeFormsRouteNames {
    LIST = 'free-forms-list',
    NEW = 'free-forms-new',
    SHOW = 'free-forms-show',
}

export enum FreeSubscriptionsRouteNames {
    LIST = 'free-subscriptions-list',
    NEW = 'free-subscriptions-new',
    SHOW = 'free-subscriptions-show',
}

export enum AuthenticationLogsRouteNames {
    LIST = 'authentication-logs-list',
    SHOW = 'authentication-logs-show'
}

export enum FailedLoginAttemptsRouteNames {
    LIST = 'failed-login-attempts-list',
    SHOW = 'failed-login-attempts-show'
}

export enum WhitelistedIpsRouteNames {
    LIST = 'whitelisted-ips-list',
    SHOW = 'whitelisted-ips-show'
}

export enum ElectronicOperatorsRouteNames {
    LIST = 'electronic-operators-list',
    NEW = 'electronic-operators-new',
    EDIT = 'electronic-operators-edit'
}

export enum InvoicesRouteNames {
    LIST = 'invoices-list'
}

export enum SSOJoinRulesRouteNames {
    LIST = 'sso-join-rules-list',
    NEW = 'sso-join-rules-new',
    EDIT = 'sso-join-rules-edit'
}

export enum AuditLogsRouteNames {
    LIST = 'audit-logs-list',
    SHOW = 'audit-logs-show'
}

export enum IndustriesRouteNames {
    LIST = 'industries-list',
    NEW = 'industries-new',
    EDIT = 'industries-edit',
}
